import { createApp } from "vue";
import App from "./App.vue";
import vueHeadful from "vue-headful";
require("@/assets/base.css");
createApp(App).component("vue-headful", vueHeadful).mount("#app");
